// Utils
import {
    enableAmplitudeTracking as enableAmplitudeTrackingJS,
    setAmplitudeUser as setAmplitudeUserJS,
    clearAmplitudeUser as clearAmplitudeUserJS,
    sendAmplitudeUserProperties as sendAmplitudeUserPropertiesJS,
    sendAmplitudeEvent as sendAmplitudeEventJS,
    initialiseAmplitude as initialiseAmplitudeJS,
    initialiseAmplitudeData as initialiseAmplitudeDataJS,
    getAmplitudeDeviceId as getAmplitudeDeviceIdJS,
} from './amplitudeServiceJS';

import {
    setAmplitudeUser as setAmplitudeUserCapacitor,
    clearAmplitudeUder as clearAmplitudeUserCapacitor,
    sendAmplitudeUserProperties as sendAmplitudeUserPropertiesCapacitor,
    sendAmplitudeEvent as sendAmplitudeEventCapacitor,
} from './amplitudeServiceCapacitor';

import { Capacitor } from '@capacitor/core';
import { CAPACITOR_AMPLITUDE_PLUGIN } from '../../capacitor_plugins/pluginConstants';

const passToCapacitor = () => Capacitor.isPluginAvailable(CAPACITOR_AMPLITUDE_PLUGIN);

export const getAmplitudeDeviceId = getAmplitudeDeviceIdJS;
export const enableAmplitudeTracking = enableAmplitudeTrackingJS;

export const setAmplitudeUser = passToCapacitor() ? setAmplitudeUserCapacitor : setAmplitudeUserJS;

export const clearAmplitudeUser = passToCapacitor() ? clearAmplitudeUserCapacitor : clearAmplitudeUserJS;

export const sendAmplitudeUserProperties = passToCapacitor()
    ? sendAmplitudeUserPropertiesCapacitor
    : sendAmplitudeUserPropertiesJS;

export const sendAmplitudeEvent = passToCapacitor() ? sendAmplitudeEventCapacitor : sendAmplitudeEventJS;

export const initialiseAmplitude = initialiseAmplitudeJS;
export const initialiseAmplitudeData = initialiseAmplitudeDataJS;
